import React from "react";

import { isTrowserRollout } from "Intuit/TrowserUtils";
import { Link } from "react-router-dom";

import CobaltButton, { LinkButton } from "Cobalt/Button";
import Icon from "Common/Icon";
import Button from "Theme/Button";

type BackButtonProps = React.ElementProps<typeof Button>;
export const BackButton = ({ ...rest }: BackButtonProps) => (
  <LinkButton color="ghost" size="medium" {...rest}>
    Back
  </LinkButton>
);
type RoutedBackButtonProps = {
  href?: string;
} & React.ElementProps<typeof BackButton>;

export const RoutedBackButton = ({ href, ...rest }: RoutedBackButtonProps) => {
  return <Link to={href} component={BackButton} {...rest} />;
};

type SaveButtonProps = {
  submitting?: boolean;
  disabled?: boolean;
  buttonText?: string | Array<any> | React.ReactNode;
  buttonTextClicked?: string;
  type?: "button" | "submit";
};
export const SaveButton = ({ submitting, disabled, buttonText, buttonTextClicked, type, float = "right", ...rest }: SaveButtonProps) => (
  <Button
    size="medium"
    classicProps={{
      style: {
        float,
      },
    }}
    intuitProps={{
      style: isTrowserRollout()
        ? undefined
        : {
            float,
          },
    }}
    cobaltProps={{
      style: {
        float,
      },
    }}
    type={type || "submit"}
    disabled={submitting || disabled}
    {...rest}
  >
    {submitting ? (
      <span>
        <Icon icon="spinner" spin="pulse" mr={2} />
        {buttonTextClicked || "Saving..."}
      </span>
    ) : (
      <span>{buttonText || "Save and Continue"}</span>
    )}
  </Button>
);
